var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidelogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 168.223,
    height: 45.804,
    viewBox: "0 0 168.223 45.804",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -531.815,
    y1: 201.732,
    x2: -530.811,
    y2: 201.732,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26d09b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87d46a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 310.439,
    y1: 0.96,
    x2: 453.469,
    y2: 0.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -585.015,
    y1: 208.662,
    x2: -584.013,
    y2: 208.662,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#326483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c9aa3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -215.891,
    y1: 201.732,
    x2: -214.927,
    y2: 201.732,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 310.487,
    y1: 0.948,
    x2: 453.538,
    y2: 0.948,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 270.654,
    y1: -693.177,
    x2: 102.39,
    y2: -261.388,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 178.553,
    y1: 1.315,
    x2: 350.735,
    y2: 1.315,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 179.94,
    y1: 1.197,
    x2: 501.724,
    y2: 1.197,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -266.913,
    y1: 208.662,
    x2: -266.081,
    y2: 208.662,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ribbash_Logo",
    "data-name": "Ribbash Logo",
    transform: "translate(-52.38 -51.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M278.247,121.349H273.37V102.38h10.017c4.793,0,8.13,2.611,8.13,6.394a5.854,5.854,0,0,1-4.529,5.483l4.995,7.087h-5.452l-4.066-6.5H278.25v6.506Zm0-15.585V111.7H282.6c2.294,0,4.036-1.171,4.036-2.931,0-1.918-1.742-3.01-4.036-3.01Z",
    transform: "translate(-164.473 -37.994)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M353.4,100.758a2.542,2.542,0,1,1,2.527,2.263A2.3,2.3,0,0,1,353.4,100.758Zm4.706,4.077v13.641H353.75V104.834Z",
    transform: "translate(-224.036 -35.121)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M391.37,119.558a6.706,6.706,0,0,1-2.762-.56,6.12,6.12,0,0,1-2.2-1.624v1.652H382.11V99.26h4.355v7.78a6,6,0,0,1,2.169-1.627,6.526,6.526,0,0,1,2.734-.558c4.153,0,7.056,3.036,7.056,7.353S395.493,119.558,391.37,119.558Zm-5.084-7.353a3.895,3.895,0,1,0,3.892-3.757,3.706,3.706,0,0,0-3.892,3.757Z",
    transform: "translate(-245.403 -35.672)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M461.763,119.558A6.686,6.686,0,0,1,459,119a6.143,6.143,0,0,1-2.2-1.624v1.652h-4.3V99.26h4.355v7.78a5.985,5.985,0,0,1,2.171-1.627,6.537,6.537,0,0,1,2.736-.558c4.153,0,7.059,3.036,7.059,7.353S465.886,119.558,461.763,119.558Zm-5.082-7.353a3.895,3.895,0,1,0,3.892-3.757A3.706,3.706,0,0,0,456.681,112.206Z",
    transform: "translate(-297.792 -35.672)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M532.448,121.684h4.358v13.641h-4.358v-1.885a6.2,6.2,0,0,1-5.053,2.424c-4.181,0-7.115-3.038-7.115-7.353s2.931-7.353,7.115-7.353a6.2,6.2,0,0,1,5.053,2.424Zm-.028,6.821a3.893,3.893,0,1,0-3.892,3.836A3.738,3.738,0,0,0,532.42,128.5Z",
    transform: "translate(-348.237 -51.971)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M598.711,135.725c-4.008,0-6.915-2.156-6.882-5.14h3.688c0,1.358,1.366,2.317,3.253,2.317,1.6,0,2.759-.693,2.759-1.6,0-1.146-1.683-1.465-3.483-1.627-3.312-.373-6.069-.852-6.069-4.184,0-2.662,2.757-4.583,6.388-4.583,3.984,0,6.854,1.972,6.854,4.716h-3.834c0-1.118-1.307-1.893-3.046-1.893-1.338,0-2.412.639-2.44,1.545,0,.905,1.3,1.171,2.99,1.412,3.02.373,6.823.933,6.823,4.13C605.706,133.674,602.865,135.725,598.711,135.725Z",
    transform: "translate(-401.488 -51.785)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M656.605,99.26v7.672a5.683,5.683,0,0,1,4.56-2.077,5.311,5.311,0,0,1,5.662,5.514v8.66h-4.355V111.2a2.651,2.651,0,0,0-2.788-2.823,2.988,2.988,0,0,0-3.079,2.985v7.672H652.25V99.26Z",
    transform: "translate(-446.457 -35.672)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M279.881,204l1.5-5.14h1.11l-1.757,5.849h-1.67l-1.243-4.731-1.235,4.731h-1.675l-1.765-5.849h1.118l1.514,5.14,1.353-5.14h1.422Z",
    transform: "translate(-164.309 -109.8)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M312.855,204.67a2.246,2.246,0,0,1,2.432,2.225c0,.1-.01.222-.018.322l-3.857-.008a1.488,1.488,0,0,0,2.782.448l.918.125a2.477,2.477,0,0,1-4.713-.893A2.263,2.263,0,0,1,312.855,204.67Zm1.414,1.877a1.268,1.268,0,0,0-.483-.816,1.493,1.493,0,0,0-.956-.307,1.364,1.364,0,0,0-1.407,1.123Z",
    transform: "translate(-192.033 -114.124)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M343.61,204.709V198.86h2.882c1.235,0,2.11.662,2.11,1.57a1.185,1.185,0,0,1-.253.749,1.351,1.351,0,0,1-.693.458,1.437,1.437,0,0,1,1.128,1.4c0,.977-.939,1.67-2.253,1.67Zm1.082-5.033v1.578h1.642c.693,0,1.182-.322,1.182-.785s-.486-.793-1.182-.793h-1.642Zm1.657,2.355h-1.655v1.859h1.657c.783,0,1.343-.4,1.343-.933s-.56-.923-1.343-.923Z",
    transform: "translate(-216.75 -109.8)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M370.715,209.532v-.537a1.761,1.761,0,0,1-.645.519,1.945,1.945,0,0,1-.834.184,1.742,1.742,0,0,1-1.857-1.8V205.34h.982v2.5a1.009,1.009,0,0,0,1.089,1.066,1.27,1.27,0,0,0,.481-.084,1.237,1.237,0,0,0,.409-.248,1.165,1.165,0,0,0,.271-.373,1.1,1.1,0,0,0,.092-.442V205.34h.972v4.194h-.962Z",
    transform: "translate(-234.441 -114.623)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M388.4,198.888a.531.531,0,0,1,.179-.394.646.646,0,0,1,.859,0,.523.523,0,0,1,0,.788.646.646,0,0,1-.859,0A.531.531,0,0,1,388.4,198.888Zm1.1,1.233v4.194h-.972V200.12Z",
    transform: "translate(-250.085 -109.406)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M398.122,197.89v6.1h-.972v-6.1Z",
    transform: "translate(-256.597 -109.078)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M406.412,199.609a2.185,2.185,0,0,1,.923.187,2.013,2.013,0,0,1,.734.547V197.87h.982v6.1h-.957v-.588a2.052,2.052,0,0,1-.744.56,2.274,2.274,0,1,1-.939-4.332Zm-1.325,2.266a1.513,1.513,0,1,0,1.514-1.422A1.423,1.423,0,0,0,405.087,201.875Z",
    transform: "translate(-261.777 -109.063)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M438.25,198.86h2.169c2.217,0,3.7,1.164,3.7,2.926s-1.476,2.923-3.7,2.923H438.25Zm2.171.826h-1.1v4.2h1.1c1.56,0,2.614-.811,2.614-2.1s-1.054-2.1-2.614-2.1Z",
    transform: "translate(-287.186 -109.8)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M464.66,198.888a.531.531,0,0,1,.179-.394.646.646,0,0,1,.859,0,.523.523,0,0,1,0,.788.646.646,0,0,1-.859,0A.531.531,0,0,1,464.66,198.888Zm1.1,1.23v4.194h-.972V200.12Z",
    transform: "translate(-306.842 -109.406)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M476.514,208.994v-.537a2.027,2.027,0,0,1-.734.527,2.216,2.216,0,1,1,.008-4.077,2.047,2.047,0,0,1,.737.54v-.565h.972v4.125a2.136,2.136,0,0,1-2.4,2.141,2.243,2.243,0,0,1-2.35-1.662l.9-.1a1.343,1.343,0,0,0,.522.721,1.545,1.545,0,0,0,.893.279A1.327,1.327,0,0,0,476.514,208.994Zm.036-2.015a1.511,1.511,0,0,0-3.02,0,1.514,1.514,0,0,0,3.02,0Z",
    transform: "translate(-312.721 -114.167)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M495.89,198.888a.531.531,0,0,1,.179-.394.646.646,0,0,1,.859,0,.523.523,0,0,1,0,.788.646.646,0,0,1-.859,0A.531.531,0,0,1,495.89,198.888Zm1.1,1.23v4.194h-.972V200.12Z",
    transform: "translate(-330.085 -109.406)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M504.143,203.076h-.7v-.7h.757l.128-1.018h.8v1.018h1.118v.7h-1.118v2.258a.616.616,0,0,0,.668.644,2.046,2.046,0,0,0,.514-.074v.719a2.888,2.888,0,0,1-.811.115,1.274,1.274,0,0,1-1.353-1.348Z",
    transform: "translate(-335.704 -111.661)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M521.12,204.838h.982v4.194h-.982V208.4a2.017,2.017,0,0,1-.744.591,2.238,2.238,0,0,1-.959.2,2.265,2.265,0,1,1,.959-4.325,1.992,1.992,0,0,1,.744.591Zm-.008,2.1a1.51,1.51,0,1,0-1.5,1.463,1.432,1.432,0,0,0,1.5-1.463Z",
    transform: "translate(-345.885 -114.123)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M541.884,197.89v6.1h-.974v-6.1Z",
    transform: "translate(-363.591 -109.078)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M560.556,202.926v1.783H559.51V198.86h2.468c1.5,0,2.568.852,2.568,2.033s-1.072,2.033-2.578,2.033Zm0-3.248V202.1H561.8c.972,0,1.675-.5,1.667-1.207s-.693-1.215-1.667-1.215Z",
    transform: "translate(-377.434 -109.8)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M583.674,204.9v.537a1.39,1.39,0,0,1,.519-.5,1.531,1.531,0,0,1,.724-.187,1.9,1.9,0,0,1,.586.107v.793a2.1,2.1,0,0,0-.711-.133,1.133,1.133,0,0,0-1.079,1.274v2.3h-.982V204.9h.944Z",
    transform: "translate(-394.716 -114.184)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M599.234,206.936a2.5,2.5,0,1,1-2.488-2.266A2.284,2.284,0,0,1,599.234,206.936Zm-.974,0a1.51,1.51,0,1,0-1.514,1.463,1.439,1.439,0,0,0,1.514-1.463Z",
    transform: "translate(-403.297 -114.124)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M618.627,199.609a2.2,2.2,0,0,1,.926.187,2.036,2.036,0,0,1,.734.547V197.87h.982v6.1h-.956v-.588a2.052,2.052,0,0,1-.744.56,2.231,2.231,0,0,1-.941.192,2.262,2.262,0,1,1,0-4.524Zm-1.325,2.266a1.512,1.512,0,1,0,1.514-1.422,1.423,1.423,0,0,0-1.514,1.422Z",
    transform: "translate(-419.723 -109.063)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M642.645,209.532v-.537a1.761,1.761,0,0,1-.644.519,1.945,1.945,0,0,1-.834.184,1.744,1.744,0,0,1-1.857-1.8V205.34h.982v2.5a1.009,1.009,0,0,0,1.089,1.066,1.27,1.27,0,0,0,.481-.084,1.237,1.237,0,0,0,.409-.248,1.128,1.128,0,0,0,.271-.373,1.058,1.058,0,0,0,.092-.442V205.34h.972v4.194h-.962Z",
    transform: "translate(-436.826 -114.623)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M664.18,206.266l-.939.107a1.257,1.257,0,0,0-.491-.678,1.486,1.486,0,1,0-.841,2.734,1.477,1.477,0,0,0,.844-.253,1.268,1.268,0,0,0,.5-.673l.939.107a2.231,2.231,0,0,1-2.279,1.588,2.27,2.27,0,1,1-.008-4.529A2.175,2.175,0,0,1,664.18,206.266Z",
    transform: "translate(-451.845 -114.124)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M680.943,203.076h-.7v-.7H681l.128-1.018h.8v1.018h1.118v.7H681.93v2.258a.616.616,0,0,0,.667.644,2.045,2.045,0,0,0,.514-.074v.719a2.875,2.875,0,0,1-.811.115,1.274,1.274,0,0,1-1.353-1.348Z",
    transform: "translate(-467.288 -111.661)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M696.282,209.187c-1.207,0-2.082-.67-2.082-1.6h.9c0,.5.5.859,1.181.859.614,0,1.054-.256,1.046-.6,0-.437-.711-.545-1.171-.6-1.072-.148-1.882-.274-1.882-1.274,0-.77.8-1.33,1.839-1.33,1.179,0,2.046.6,2.046,1.437h-.9c-.01-.412-.486-.7-1.146-.7-.5,0-.91.248-.91.588,0,.315.343.412,1.082.529.872.133,2,.3,2,1.256C698.271,208.581,697.445,209.187,696.282,209.187Z",
    transform: "translate(-477.678 -114.102)",
    fill: "#1e1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M113.385,184.56l.107.074-.113-.072Z",
    transform: "translate(-45.4 -99.157)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M129.867,169.123V184.8L113.1,173.276l.184-.136h0l5.355-3.961.079-.059h11.145Z",
    transform: "translate(-45.191 -87.666)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M111.983,184.6l.1.072-.1-.069Z",
    transform: "translate(-44.358 -99.187)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M113.385,184.56l.107.074-.113-.072Z",
    transform: "translate(-45.4 -99.157)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M113.1,174.3l.184-.136h0l4.959-3.67,11.618,15.327Z",
    transform: "translate(-45.191 -88.686)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M72.561,69.209,52.38,51.33,90.072,69.209H72.561Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M52.38,97.134V51.33L72.563,69.209Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M52.38,149.165,90.1,121.24H72.563Z",
    transform: "translate(0 -52.031)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M123.28,184.672l-.1-.069,0,0Z",
    transform: "translate(-52.693 -99.187)",
    fill: "url(#linear-gradient-9)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidelogo);
export default __webpack_public_path__ + "static/media/sidelogo.418cd11554f050689baa6b506b19bfab.svg";
export { ForwardRef as ReactComponent };